<template>
  <div class="connect_bg">
    <div
      :class="{
        connect_wrap: true,
        connect_vip_wrap: $store.state.user.vip_left > 0,
      }"
    >
      <div class="connect_close_btn" @click="close"></div>
      <div class="connecting_wrap" v-if="!isFailed">
        <div class="connecting_icon"></div>
        <div class="connecting_name">{{ name }}</div>
        <div class="connecting_channel">
          <div class="connecting_channel_left"></div>
          <div
            class="connecting_channel_name"
            v-if="$store.state.user.vip_left > 0"
          >
            高速通道 正在连接...
          </div>
          <div class="connecting_channel_name" v-else>公共通道</div>
          <div class="connecting_channel_right"></div>
        </div>
        <div class="connecting_title" v-if="rule > 0">
          正在使用代理模式连接设备
        </div>
        <!--				<div class="connecting_title" v-else>正在连接...</div>-->
      </div>
      <div class="connecting_wrap" v-else>
        <div class="connecting_icon connecting_icon_failed"></div>
        <div class="connecting_error_title">连接失败</div>
        <div class="connecting_tips">失败原因：设备异常 {{ connectRet }}</div>
        <div class="connecting_tips">请检查设备是否已连接网络</div>
        <div class="connecting_tips" v-if="false">
          建议XXXXXXXXXXXXXXXXXXXX <span>帮助指引</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {};
  },
  props: ["isFailed", "name", "connectRet", "rule"],
  methods: {
    close: function () {
      let _that = this;
      _that.$emit("close");
    },
  },
  watch: {
    rule: function (newVal) {},
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.connect_bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 9;
  .connect_wrap {
    width: 460px;
    height: 320px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -160px;
    margin-left: -230px;
    background-color: #f5f5f5;
    border-radius: 5px;
    box-shadow: 0px 0px 14px 2px #999999;

    .connect_close_btn {
      width: 20px;
      height: 20px;
      position: absolute;
      right: 20px;
      top: 14px;
      cursor: pointer;
      background-image: url(../assets/common/close2.svg);
      background-size: 100% 100%;
    }
    .connecting_icon {
      width: 203px;
      height: 133px;
      background-image: url(../assets/home/node/connecting_icon.svg);
      background-size: 100% auto;
      margin: 50px auto 15px auto;
    }
    .connecting_icon_failed {
      background-image: url(../assets/home/node/connect_failed_icon.svg);
    }
    .connecting_error_title {
      font-size: 14px;
      color: #666666;
      font-weight: bolder;
      text-align: center;
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .connecting_title {
      font-size: 14px;
      color: #666666;
      font-weight: bolder;
      text-align: center;
      margin-top: 10px;
    }
    .connecting_name {
      color: #1f5de3;
      font-size: 16px;
      text-align: center;
      margin-bottom: 15px;
      font-weight: bolder;
    }
    .connecting_tips {
      color: #666666;
      font-size: 12px;
      text-align: center;
      margin-top: 3px;
      span {
        color: #1f5de3;
        margin-left: 5px;
        cursor: pointer;
      }
    }
    .connecting_channel {
      width: 330px;
      height: 42px;
      background-color: #5187fd;
      background-image: linear-gradient(to right, #1f5de3, #5187fd);
      color: #c5f1ff;
      line-height: 42px;
      text-align: center;
      border-radius: 21px;
      margin: 0 auto;
      font-size: 13px;
      .connecting_channel_left {
        display: inline-block;
        vertical-align: top;
        width: 42px;
        height: 42px;
        line-height: 42px;
        background-image: url(../assets/home/node/connect_channel_left.png);
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 32px 20px;
        margin-right: 20px;
      }
      .connecting_channel_name {
        display: inline-block;
        vertical-align: top;
        height: 42px;
        line-height: 42px;
      }
      .connecting_channel_right {
        display: inline-block;
        vertical-align: top;
        height: 42px;
        width: 42px;
        line-height: 42px;
        background-image: url(../assets/home/node/connect_channel_right.png);
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 32px 20px;
        margin-left: 20px;
      }
    }
  }
  .connect_wrap.connect_vip_wrap {
    .connecting_channel {
      background-image: linear-gradient(to right, #f2d7b3, #d9ad84);
      .connecting_channel_left {
        background-image: url(../assets/home/node/connect_channel_vip_left.png);
      }
      .connecting_channel_name {
        color: #795c24;
        font-weight: bolder;
        font-size: 14px;
      }
      .connecting_channel_right {
        background-image: url(../assets/home/node/connect_channel_vip_right.png);
      }
    }
    .connecting_title {
      color: #795c24;
    }
  }
}
</style>